// extracted by mini-css-extract-plugin
export default {"icon":"ELJ87vwpVhETzAkX","iconNeutral":"PSfXFtmQgFs1M_el ELJ87vwpVhETzAkX","iconError":"q87geFyv3I2_e80U ELJ87vwpVhETzAkX","bodyText":"N02G4pExgvOjp3k7"};